export default "__VITE_ASSET__142fb07c__"